function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M412.353,95.197c-6.258-6.254-16.383-6.246-22.629,0c-3.746,3.742-8.317,6.394-14.262,8.367l-62.047-62.047 c1.977-5.946,4.668-10.446,8.426-14.203c6.246-6.246,6.254-16.371,0-22.625s-16.379-6.25-22.629,0 c-16.617,16.617-21.461,37.207-22.39,75.434c-0.102,4.309,1.535,8.477,4.547,11.562c3.008,3.086,7.137,4.836,11.45,4.836h1.481 c7.957,0,14.426-6.422,14.488-14.379l26.047,26.047c-7.676,0.145-16.094,0.183-26.098,0.094l-32.05-0.438 c-39.621-0.625-98.606-4.406-135.965,32.95c-24.598,24.602-31.805,61.262-33.301,99.242c-0.168,4.309,1.426,8.5,4.41,11.61 c2.988,3.106,7.114,4.875,11.426,4.875h0.348c8.55,0,15.543-6.778,15.828-15.324c0.246-7.348,0.722-14.516,1.508-21.434 c13.226,13.226,40.117,40.121,56.371,56.375c-19.383,2.07-39.699,1.324-57.465,1.058l-32.008-0.446 c-63.61-0.645-82.473,1.785-103.149,22.461c-6.25,6.25-6.258,16.375,0,22.629c6.25,6.254,16.379,6.25,22.625,0 c4.114-4.114,8.324-6.992,14.363-9.004l62.004,62c-2.023,5.988-4.707,11.11-8.484,14.886c-6.25,6.246-6.254,16.375,0,22.629 c6.254,6.25,16.379,6.246,22.625,0c17.094-17.094,21.934-44.57,22.782-75.543c0.117-4.278-1.5-8.418-4.481-11.484 c-2.981-3.066-7.078-4.805-11.355-4.805h-1.805c-7.813,0-14.168,6.285-14.25,14.098L82.816,308.72 c7.351-0.082,15.711-0.058,25.461,0.043l32.016,0.438c39.789,0.606,98.695,4.371,135.953-32.886 c26.117-26.117,32.484-71.211,33.242-108.106c0.187-8.981-7-16.394-15.984-16.394c-8.656,0-15.801,6.898-15.922,15.554 c-0.098,6.687-0.43,21.629-1.266,29.379c-16.645-16.641-36.222-36.222-55.906-55.906c19.218-1.992,39.27-1.262,56.742-0.988 l32.027,0.446c55.957,0.516,82.691-1.992,103.176-22.473C418.598,111.575,418.602,101.45,412.353,95.197z M267.321,233.013 c-3.606,8.137-8.098,15.07-13.711,20.68c-5.789,5.789-12.715,9.969-20.164,13.328l-83.48-83.484 c3.383-7.582,7.683-14.414,13.379-20.11c5.95-5.95,13.074-10.242,20.75-13.641C211.915,177.603,243.977,209.67,267.321,233.013z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgDna = function SvgDna(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 417.039 417.039",
    style: {
      enableBackground: "new 0 0 417.039 417.039"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDna, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dna.701c38d5.svg";
export { ForwardRef as ReactComponent };